import {
  Box,
  Button,
  Flex,
  Modal,
  ModalContent,
  ModalFooter,
  ModalTitle,
} from '@modusign/design-system';

import ModalCloseButton from '../ModalCloseButton';

interface TemplateExitModalProps {
  exitStatus: 'idle' | 'save' | 'unsave';
  onCloseButtonClick: () => void;
  onSaveExitClick: () => void;
  onUnsaveExitClick: () => void;
}

function TemplateExitModal({
  exitStatus,
  onCloseButtonClick,
  onSaveExitClick,
  onUnsaveExitClick,
}: TemplateExitModalProps) {
  if (exitStatus === 'idle') {
    return null;
  }

  if (exitStatus === 'save') {
    return (
      <Modal isOpen maxWidth="xxs" onClose={onCloseButtonClick}>
        <Flex height={0} justifyContent="end" width="100%">
          <ModalCloseButton aria-label="close" onClick={onCloseButtonClick} />
        </Flex>
        <ModalTitle>저장하고 나가기</ModalTitle>
        <ModalContent>
          <Box as="p" mb={0} textAlign="center">
            입력한 내용이 아직 저장되지 않았습니다.
            <br />
            저장하고 나갈까요?
          </Box>
        </ModalContent>
        <ModalFooter>
          <Button mr={2} onClick={onUnsaveExitClick}>
            나가기
          </Button>
          <Button ml={2} variant="primary" width="regular" onClick={onSaveExitClick}>
            저장하고 나가기
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  if (exitStatus === 'unsave') {
    return (
      <Modal isOpen={exitStatus === 'unsave'} maxWidth="xxs" onClose={onCloseButtonClick}>
        <ModalTitle>나가기</ModalTitle>
        <ModalContent>
          <Box as="p" mb={0} textAlign="center">
            해당 문서는 저장되지 않습니다.
            <br />
            나가시겠습니까?
          </Box>
        </ModalContent>
        <ModalFooter>
          <Button mr={2} onClick={onCloseButtonClick}>
            취소
          </Button>
          <Button ml={2} variant="primary" width="regular" onClick={onUnsaveExitClick}>
            확인
          </Button>
        </ModalFooter>
      </Modal>
    );
  }

  return null;
}

export default TemplateExitModal;
